import { Box, BoxProps, Image } from '@chakra-ui/react'

interface IProps extends BoxProps {
  countryCode: string
}
export function Flag({ countryCode, ...rest }: IProps) {
  if (!countryCode) {
    return <></>
  }
  return (
    <Box
      width={{ base: '23px', md: '16px', xl: '18px', '2xl': '23px' }}
      height={{ base: '15px', md: '10px', xl: '12px', '2xl': '15px' }}
      {...rest}
    >
      <Image
        borderRadius="3px"
        width="100%"
        height="100%"
        objectFit="cover"
        src={`/icons/flags/${countryCode?.toLowerCase()}.svg`}
      />
    </Box>
  )
}
